<!--
 * @Desc: 业务员查看二级分销商所有二维码
 * @Author: may.li
 * @Date: 2023-03-09 09:20:50
 * @LastEditors: may.li
 * @LastEditTime: 2023-03-09 09:43:24
-->
<template>
	<div class="page page_fans page_adress">
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData">
			<div class="list">
				<div class="item" v-for="(item,index) in dataList" :key="index">
					<div class="item_l">
						<div class="user_name">码编号：{{ item.qrcode_num }}</div>
					</div>
				</div>
			</div>
		</van-list>
	</div>
</template>
<script>
export default {
	data(){
		return{
			token: null,
			agent_uuid: null,
			page: 1,
			size: 10,
			dataList: [],
			loading: false,
			finished: false,
		}
	},
	created(){
		this.token = this.$store.getters.token;
		this.agent_uuid = this.$route.query.agent_uuid;
	},
	methods: {
		/**
		 * @name: 获取数据
		 * @return {*}
		 * @desc: 
		 */		
		getData(){
			let params = {
				token: this.token,
				page: this.page,
				size: this.size,
				agent_uuid: this.agent_uuid
			};
			this.$api.salesman.agentqrcodelist(params).then(res=>{
				if(res.code == 200){
					let list = res.result;
					if(list && list.length){
						for(let i in list){
							this.dataList.push(list[i]);
						};
						if(list.length < this.size){
							this.finished = true;
						}else{
							this.page++;
							this.loading = false;
						}
					}else{
						this.finished = true;
					}
				}else{
					this.finished = true;
					this.$toast(res.message);
				}
			})
		}
	},
}
</script>